export enum AppName {
  ASKNEBULA = 'asknebula',
  GUIDANCE = 'guidance',
  BIRTHCHARTS = 'birthcharts',
  APP = 'app',
}
